import { TAssetMetadata } from "@dl/declarations";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";

import { ControlledSystemTextInput } from "@cms/components/data/TextInput";
import { FormActions, FormWrapper } from "@cms/components/forms/FormContainer";
import { BROWSER_EVENTS, POST_SET_VALUE_OPTIONS } from "@cms/utils/constants";

interface AssetMetadataDialogProps {
    defaultValues: TAssetMetadata
    handleSaveChanges: (data: TAssetMetadata) => void
}

export const AssetMetadataDialog: React.FC<AssetMetadataDialogProps> = (props) => {
    const { defaultValues, handleSaveChanges } = props

    const methods = useForm<TAssetMetadata>({
        defaultValues,
        mode: 'all',
        resolver: yupResolver(yup.object({
            headline: yup.string(),
            credit: yup.string(),
            copyright: yup.string(),
            article_caption: yup.string(),
            link: yup.string().url('Invalid URL'),
        }) as any)
    })

    const { watch, handleSubmit, setValue } = methods

    const [
        src_url,
        headline,
        credit,
        copyright,
    ] = watch(['src_url', 'headline', 'credit', 'copyright']);


    const handleSubmitForm = handleSubmit((data: TAssetMetadata) => {
        handleSaveChanges(data)
        handleClose()
    })

    const handleClose = () => {
        dispatchEvent(new Event(BROWSER_EVENTS.CLOSE_MODAL))
    }

    useEffect(() => {
        const timerId = setTimeout(() => {
            let caption = ""

            if (headline) {
                caption += `${headline}; `
            }

            if (credit) {
                caption += `Illustration: ${credit}; `
            }

            if (copyright) {
                caption += `Source: ${copyright}`
            }

            setValue('article_caption', caption, POST_SET_VALUE_OPTIONS)
        }, 500);

        return () => {
            clearTimeout(timerId)
        }
    }, [headline, credit, copyright])


    return (
        <FormProvider {...methods}>
            <FormWrapper
                formOptions={{
                    formSize: "full",
                }}
                submitOptions={{
                    handleSubmit: handleSubmitForm
                }}
            >
                <img src={src_url} alt={headline} className="w-full mx-auto max-h-72 object-contain" />

                <ControlledSystemTextInput
                    name='headline'
                    description='Headline'
                    inputSize='full'
                />

                <ControlledSystemTextInput
                    name='credit'
                    description='Credit'
                    inputSize='full'
                    placeholder='Add Illustration credits'
                />

                <ControlledSystemTextInput
                    name='copyright'
                    description='Copyright'
                    inputSize='full'
                    placeholder='Add copyright from the stock image'
                />

                <ControlledSystemTextInput
                    name='link'
                    description='Add a link URL'
                    inputSize='full'
                />

                <ControlledSystemTextInput
                    name='article_caption'
                    description='Article Caption'
                    inputSize='full'
                />

                <FormActions
                    submitOptions={{
                        label: 'Save'
                    }}
                    cancelOptions={{
                        label: 'Cancel',
                        handleCancel: handleClose
                    }}
                />
            </FormWrapper>
        </FormProvider>
    )
}